import ModularModule from './containers/modularModule'

export {default as ModularModuleLayout} from './components/modularModuleLayout'

export default ModularModule
